<template>
  <ApplicationPageHeaderVideo :video="{ src: '/videos/home-jumbotron.mp4', type: 'video/mp4' }">
    <div class="max-w-[min(100%,60ch)] lg:max-w-[70ch] xl:max-w-[80ch] p-4 font-logo text-secondary-100 lg:border-y lg:border-y-secondary-100/20 lg:py-8 text-shadow-lg">
      <h1 class="mb-4 text-2xl lg:text-3xl xl:text-4xl text-shadow text-shadow-green-900">
        Ontdek hoe dieren worden behandeld
      </h1>

      <h2 class="text-pretty text-xl lg:text-2xl font-bold text-shadow text-shadow-green-900">
        Bekijk undercover beeldmateriaal uit Belgische en Nederlandse stallen
      </h2>
    </div>
  </ApplicationPageHeaderVideo>
</template>
